export function CircleProgressBarAnimation({
  start,
  end,
  duration,
  onUpdate,
  onComplete,
}: {
  start: number
  end: number
  duration: number
  onUpdate: (currentValue: number) => void
  onComplete?: () => void
}): void {
  const startTime = performance.now()

  function animate(currentTime: number): void {
    const elapsed = currentTime - startTime
    const progress = Math.min(elapsed / duration, 1) // Ensure progress is between 0 and 1
    const currentValue = start + (end - start) * progress

    onUpdate(currentValue)

    if (progress < 1) {
      requestAnimationFrame(animate)
    } else if (onComplete) {
      onComplete()
    }
  }

  requestAnimationFrame(animate)
}
